import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage/view.scss */
:host {
  display: block;
  height: 100%;
}

.mypage-link-row {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 12px;
}

.mypage-link-main {
  min-width: 0;
}

.mypage-link-action {
  grid-column: 1/-1;
  justify-self: stretch;
  width: 100%;
  min-height: 40px;
  margin-top: 2px;
  white-space: nowrap;
}

.mypage-settings-card {
  display: block;
}

.mypage-settings-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
}

.mypage-settings-main {
  min-width: 0;
}

.mypage-settings-icon {
  width: 36px;
  height: 36px;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background-color: var(--th-surface-soft);
}`],
})
export class PageMypageComponent implements OnInit {
    public samsungHealthConnected: boolean = false;
    public samsungHealthReady: boolean = false;
    public samsungHealthAuthUrl: string = '';
    public profileMessage: string = '';
    public profileErrorMessage: string = '';

    public profile: any = {
        name: '',
        email: '',
        role: 'user',
        age: '',
        gender: '',
        constitution: '',
        height: '',
        weight: '',
        conditions: []
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadProfile();
        await this.loadSamsungHealthSetup();
        this.applyPageMessageState();
        await this.service.render();
    }

    public async loadProfile() {
        let res = await wiz.call("profile");
        if (res.code === 200 && res.data) {
            const data = res.data.data || res.data;
            this.profile = { ...this.profile, ...data };
            this.samsungHealthConnected = !!data.samsung_health_connected;
        }
    }

    public async loadSamsungHealthSetup() {
        let res = await wiz.call("samsung_health_auth_url");
        if (res.code === 200 && res.data) {
            this.samsungHealthReady = !!res.data.ready;
            this.samsungHealthAuthUrl = res.data.auth_url || '';
            return;
        }

        this.samsungHealthReady = false;
        this.samsungHealthAuthUrl = '';
    }

    public applyPageMessageState() {
        const urlParams = new URLSearchParams(window.location.search);
        const samsungHealthResult = urlParams.get('samsung_health');
        const profileResult = urlParams.get('profile');

        if (profileResult === 'updated') {
            this.profileMessage = '개인정보를 저장했습니다.';
            urlParams.delete('profile');
        }

        if (samsungHealthResult === 'success') {
            this.samsungHealthConnected = true;
            urlParams.delete('samsung_health');
        }

        if (samsungHealthResult === 'error') {
            urlParams.delete('samsung_health');
            urlParams.delete('reason');
        }

        if (profileResult || samsungHealthResult) {
            const query = urlParams.toString();
            history.replaceState({}, '', `${window.location.pathname}${query ? '?' + query : ''}`);
        }
    }

    public goSettings() {
        this.service.href('/settings');
    }

    public goProfileEdit() {
        this.profileMessage = '';
        this.profileErrorMessage = '';
        this.service.href('/mypage/edit');
    }

    public async connectSamsungHealth() {
        if (!this.samsungHealthReady || !this.samsungHealthAuthUrl) {
            await this.loadSamsungHealthSetup();
        }

        if (!this.samsungHealthReady || !this.samsungHealthAuthUrl) {
            return;
        }

        location.href = this.samsungHealthAuthUrl;
    }

    public async disconnectSamsungHealth() {
        let res = await wiz.call("disconnect_samsung_health");
        if (res.code === 200) {
            this.samsungHealthConnected = false;
            await this.service.render();
        }
    }

    public async logout() {
        await wiz.call("logout");
        location.href = '/login';
    }

    public getConstitutionLabel(id: string): string {
        const map: any = { taeyang: '태양인', taeeum: '태음인', soyang: '소양인', soeum: '소음인', unknown: '미분류' };
        return map[id] || id;
    }

    public getConditionLabel(id: string): string {
        const map: any = {
            diabetes: '당뇨',
            hypertension: '고혈압',
            hyperlipidemia: '고지혈증',
            heart: '심장질환',
            arthritis: '관절염',
            none: '해당없음'
        };
        return map[id] || id;
    }
}

export default PageMypageComponent;